import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ChangeDetectorRef,SimpleChanges  } from '@angular/core';
import { NgClass, NgIf, NgFor, CurrencyPipe, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MatDialog } from '@angular/material/dialog';
import { StayListDialogComponent } from '../list-stay-dialog/stay-list-dialog.component';
import { ActivityListDialogComponent } from '../list-activity-dialog/activity-list-dialog.component';
import { TransferListDialogComponent } from '../list-transfer-dialog/transfer-list-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuoteViewDialogComponent } from '../quote-view/quote-view-dialog.component';
import { QuoteDetailsDialogComponent } from '../quote-details-dialog/quote-details-dialog.component';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QuoteListComponent } from "../quote-list/quote-list.component";
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { CarListDialogComponent } from '../list-car-dialog/car-list-dialog.component';

@Component({
  selector: 'cart',
  standalone: true,
  imports: [MatButtonModule, NgClass, NgFor, FuseCardComponent, NgIf, MatIconModule, CurrencyPipe, DatePipe, MatSidenavModule, MatTooltipModule, MatCheckboxModule, QuoteListComponent],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent implements OnInit {
  @Input('options') public _options: any; //Cart options
  @Input('items') public _items: any[] = [];
  @Input('trip') public _trip: any[] = [];
  @Input('itin') public _itin: any[] = [];
  @Input() flightSelectionEvent: any;  // Receive event from FlightComponent

  @Output() readonly selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly viewChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly quoteCreated: EventEmitter<any> = new EventEmitter<any>();
  @Input() flight: any;
  @Input() stay: any;

  public view : any = {
    mode:'summary',
    data: {
      cart:[]
    }
  }

  private readonly _destroy$ = new Subject<void>();

    /**
     * Constructor
     */
    constructor(private _cd: ChangeDetectorRef, private _tfmService: TFMService, private _tfmCartService: TFMCartService, private dialog: MatDialog, private _confirmationService: FuseConfirmationService)
    {
      console.log("CART CONSTUCTOR");

      // this._tfmCartService.cartViewToggle.subscribe(res => {
      //   this._tfmService.log("cart outside toggle", res);
      //   if (res) {
      //     this.view.mode = 'summary';
      //     //this.toggleReviewDrawer();
      //   }
      //   else {
      //     this.view.mode = 'review';
      //     //this.toggleReviewDrawer();
      //   }
      // });

      this.view.tripChange$ = this._tfmCartService.tripChange.subscribe(res => {
        this.view.trip = res;

        this._tfmService.saveLocalStorage("trip", this.view.trip);

        this._tfmService.log('cart tripChange', this.view);
      });

      // Collapse from review → summary when the user clicks outside the cart
      this._tfmCartService.collapseReviewToSummary$
        .pipe(takeUntil(this._destroy$))
        .subscribe(() => {
          if (this.view.mode === 'review') {
            this.view.mode = 'summary';
            this.viewChange.emit({ mode: this.view.mode });
            this._cd.detectChanges();
          }
        });

      //Check if we have an existing itin guid so we can load it
      this.getItin();

      this.view.cartChange$ = this._tfmCartService.cartChange.subscribe(res => {

        this.view.data.cart = res;

        this._tfmService.log('cart changed', res);

        if (this.view.data.cart.length > 0) {
          //Check if the hotel includes flights/transfers
          var hotel = this.view.data.cart.filter(x=>x.type == 'hotel').length > 0 ? this.view.data.cart.filter(x=>x.type == 'hotel')[0] : null;
          if (hotel) {
            this.view.hasIncludedFlights = hotel.item.hasIncludedFlights ? true : false;
            this.view.hasIncludedTransfers = hotel.item.hasIncludedTransfers ? true : false;
            this.view.hasIncludedCar = hotel.item.hasIncludedCar ? true : false;
          }
        }

        var itinGuid = this._tfmService.getLocalItinGuid();

        if (this.getCartTotal() > 0) {
          this.view.mode = 'summary';
          this.viewChange.emit({mode:this.view.mode});

          this._tfmService.log('cart changed and is more than zero');

          this.validateQuote(itinGuid ? "new-option" : "new-quote");
          
          this._cd.detectChanges();
        }
        this._tfmService.saveLocalStorage("cart", this.view.data.cart);

        if (itinGuid) {
          this.getItin();
          this._cd.detectChanges();
        }
        else {
          //this.validateQuote("new-quote");
          //this.getItin(this.view.data.cart.length <= 1);
          this.getItin(true);
        }
      });

      this._tfmCartService.cartItemChange.subscribe(res => {
        this._tfmService.log("cartItemChange", res);

        this.view.data.cart = this._tfmCartService.getCart();
      });
    }
    isClient = this._tfmService.view.isClient;



  ngOnChanges(changes: SimpleChanges) {
    // this._tfmService.log("ngOnChanges", "cart", changes);
    
    // if (changes['flight'] && changes['flight'].currentValue) {
    //     this.validateQuote("new-quote");
    // }
    // if (changes['stay'] && changes['stay'].currentValue) {
    //     this.validateQuote("new-quote");
    // }
  }

     /**
     * On init
     */
     ngOnInit(): void {
      this.view.options = this._options;
      this.view.search = this._options;
      this.view.trip = this._trip;
      this.view.itin = this._itin;
      this._tfmService.log("cart", this.view);

      if (this.view.options && this.view.options.loadCache) {
        this.view.trip = this._tfmService.loadLocalStorage("trip");

        this.view.data.cart = this._tfmService.loadLocalStorage("cart");
        this._tfmService.log(this.view);

        this._tfmCartService.updateTrip(this.view.trip);
        this._tfmCartService.updateCart(this.view.data.cart);
      }

      //this.getItin();

      this.view.itinGuidChange$ = this._tfmService.itinGuidChange.subscribe(res => {
        if (!res)
          this.view.itin = null;

        this._cd.detectChanges();
        this._tfmService.log("cartComponent itinGuidChange", res);
      });
    }
    ngOnDestroy() {
      this._destroy$.next();
      this._destroy$.complete();
      this.view.tripChange$.unsubscribe();
      this.view.cartChange$.unsubscribe();
    }

    selectQuote(state, quote) {
      quote.selected = state;

      this.view.quotesSelected = this.view.quotes.content.filter(x=>x.selected).map(item => `guids=${item.itinerary.guid}`).join("&");
    }

    getItin(createNew = false, action = null) {

      //Clear itin id from localstorage if this is our 1st cart item
      if (createNew) {
        //this._tfmService.clearLocalItinGuid();

        // /this.view.itin =  null;
        this._cd.detectChanges();
      }
      else {
        var itinGuid = this._tfmService.getLocalItinGuid();
        if (itinGuid) {
          this._tfmService.getItin(itinGuid).subscribe(res => {
            this.view.itin = res;
            this._tfmService.log(this.view);

            if (action == 'view-quote') {
              //this.validateQuote('view-quote');
            }
            else {
              this.getItinQuotes(res.content.itinerary.referenceID || res.content.itinerary.id);
            }

            this._cd.detectChanges();
          });
        }
      }
    }
    getCartTotal(type = null) {
      return this._tfmCartService.getCartTotal(type);
    }
    toggleReviewDrawer() {
      this.view.mode = this.view.mode == 'review' ? 'summary' : 'review';
      this.viewChange.emit({mode:this.view.mode});

      this._tfmCartService.setCartOpen(this.view.mode == 'review');

      console.log(this.view.mode);
      this._cd.detectChanges();
      // if (this.isReviewDrawerVisible()) {
      //   this.searchService(null, 'activity');
      // }
    }
    viewOptionsClick() {
      this.toggleReviewDrawer();
    }
    isReviewDrawerVisible() {
      return this.view.mode == 'review';
    }

    public getItemsFromPoint(point) {
      return this._tfmCartService.getItemsFromPoint(point);
    }

    public getPointFromIndex(index) {
      if (this.view.trip.points.filter(x=>x.index == index).length > 0)
        return this.view.trip.points.filter(x=>x.index == index)[0];

      return null;
    }

    public searchService(point, type = 'hotel') {
      this._tfmService.log("searchService", this.view, point);
      this.openModal(point, type);
    }

    public async validateQuote(action = 'validate', quote = null) { //Process all quote components to identify any missing information
      this._tfmService.log("validateQuote", action, this.view);

      if (action == 'new-quote' && this._tfmService.getLocalItinGuid()) {
        action = 'new-option';
      }
      if (action == 'new-quote') {
        this.view.itin = null;
        this.view.itin = this._tfmService.loadLocalStorage("itin");

        if (this.view.itin?.content?.itinerary) {
          delete this.view.itin.content.itinerary.guid;
          delete this.view.itin.content.itinerary.id;
          delete this.view.itin.content.itinerary.referenceID;
        }
      }

      //Check that we have basic quote information eg: email address
      if (action == 'new-quote' || (!this.view.itin || !this.view.itin.content || !this.view.itin.content.itinerary || !this.view.itin.content.itinerary.emailAddress || !this.view.itin.content.itinerary.firstName)) {
        console.log(this.view.dialogRef, this.view.dialogRef)
        if (!this._options.isClient && !this.view.dialogRef || (this.view.dialogRef && this.view.dialogRef.getState() != "OPEN")) {
          if (!this.view.itin || !this.view.itin.content || !this.view.itin.content.itinerary || !this.view.itin.content.itinerary.emailAddress || !this.view.itin.content.itinerary.firstName) {
            this.view.dialogRef = this._confirmationService.open({
              title: 'Client Information',
              message: 'We require client information before we can generate a quote. <span class="font-medium">Please provide this on the next screen?</span><br/><br/><span class="text-primary">No quote will be created if you click cancel.</span>',
              icon: {
                show: true,
                name: 'heroicons_outline:user',
                color: 'warn',
              },
              actions: {
                confirm: {
                  show: true,
                  label: 'Capture Information',
                  color: 'primary',
                },
                cancel: {
                  show: true,
                  label: 'Cancel',
                },
              },
              dismissible: false,
            });

            // Subscribe to afterClosed from the dialog reference
            this.view.dialogRef.afterClosed().subscribe((result) => {
                this._tfmService.log(result);
                if (result && result === 'confirmed')
                  this.openModal(null, 'quote-information');
            });
          }
          else {
            this.generateQuote();
          }
        }
      }
      else if (action == 'new-option') { //We need to use the current itin id as the reference when we create a new itin
        //this.view.itin.content.itinerary.referenceId
        this._tfmService.log(action, this.view);
        await this.createItin(this.view.itin.content.itinerary.referenceID || this.view.itin.content.itinerary.id, this.view.itin.content.itinerary);
      }
      else if (action == 'view-quote') {
        this.openModal(null, 'quote', quote);
      }
      else if (action == 'checkout') {
        this.checkout();
      }
      else { //we need to generate a new quote
        this.generateQuote();
      }
    }

    public checkout() {
      this._tfmService.log(this.view);

      const dialogRef = this._confirmationService.open({
        title: 'Coming Soon',
        message: 'We need a bit more time to complete this section - <span class="font-medium">Please use TFM v1 to finalise this booking.</span>',
        icon: {
          show: true,
          name: 'heroicons_outline:exclamation-triangle',
          color: 'info',
        },
        actions: {
          confirm: {
            show: true,
            label: 'Okay',
            color: 'primary',
          },
          cancel: {
            show: true,
            label: 'Cancel',
          },
        },
        dismissible: true,
      });
    }

    public openModal(item, type, quote = null) {

      var data : any = {
        data: {search: this._tfmCartService.getSearch(), trip: this.view.trip, point: item, type: type, itin: quote || this.view.itin},
        height: '95vh',
        width: '95vw',
        maxWidth: '95vw'
      };

      if (type == 'hotel') {
        let dialogRef = this.dialog.open(StayListDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {});
      }
      else if (type == 'activity') {
        let dialogRef = this.dialog.open(ActivityListDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {});
      }
      else if (type == 'transfer') {
        let dialogRef = this.dialog.open(TransferListDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {});
      }
      else if (type == 'car') {
        let dialogRef = this.dialog.open(CarListDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {});
      }
      else if (type == 'quote') {
        data.height = '95vh';

        let dialogRef = this.dialog.open(QuoteViewDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {
            //write logic to generate quote
        });
      }
      else if (type == 'quote-information') {
        let dialogRef = this.dialog.open(QuoteDetailsDialogComponent, data);

        dialogRef.afterClosed().subscribe(result => {
          if (result && result.itin) {
            this.view.itin = result.itin;
            this.generateQuote();
          }
        });
      }
    }

  generateQuote() {
    var itinObject: any = {};
    itinObject.firstName = this.view.itin.content.itinerary.firstName;
    itinObject.lastName = this.view.itin.content.itinerary.lastName;
    itinObject.emailAddress = this.view.itin.content.itinerary.emailAddress;
    itinObject.countryAccessCode = this.view.itin.content.itinerary.countryAccessCode;
    itinObject.areaCityCode = this.view.itin.content.itinerary.areaCityCode;
    itinObject.phoneNumber = this.view.itin.content.itinerary.phoneNumber;
    itinObject.remarks = this.view.itin.content.itinerary.remarks;
    itinObject.tags = this.view.itin.content.itinerary.tags;


    if (this.view.itin.content.itinerary.company) {
      itinObject.companyName = this.view.itin.content.itinerary.company.name;
      itinObject.companyAddress = this.view.itin.content.itinerary.company.address;
      itinObject.companyAddressCity = this.view.itin.content.itinerary.company.city;
      itinObject.companyAddressCode = this.view.itin.content.itinerary.company.code;
      itinObject.companyAddressCountry = this.view.itin.content.itinerary.company.country;
      itinObject.companyRegistrationNumber = this.view.itin.content.itinerary.company.registrationNumber;
      itinObject.companyVATNumber = this.view.itin.content.itinerary.company.vatNumber;
    }

    if (this.view.itin.content.itinerary.agent) {
      itinObject.externalAgentFirstName = this.view.itin.content.itinerary.agent.name;
      itinObject.externalAgentLastName = this.view.itin.content.itinerary.agent.surname;
      itinObject.externalAgentEmailAddress = this.view.itin.content.itinerary.agent.email;
      itinObject.externalAgentAgencyName = this.view.itin.content.itinerary.agent.agencyName;
      itinObject.externalAgentAgencyVATNumber = this.view.itin.content.itinerary.agent.agencyVatNumber;
    }

    if (this.view.itin && this.view.itin.content && this.view.itin.content.itinerary && this.view.itin.content.itinerary.guid) {
      //Update itin
      this._tfmService.updateItin(this.view.itin.content.itinerary.guid, this.view.itin.content.itinerary).subscribe(res => {
        this._tfmService.log("itin updated");
        this.getItin();
      });
    }
    else { //Create new quote
      this.createItin(0, itinObject);
    }
  }
    public openReviewModal(quote) {

      this._tfmService.getItinFromId(this.view.itin.content.itinerary.referenceID || this.view.itin.content.itinerary.id).subscribe(res => {
        this.dialog.open(GenericModalComponent, {
          data: {type: 'iframe', quote: res.content.itinerary},
          height: '99vh',
          width: '99vw',
          maxWidth: '99vw'
        });
      });
  }

    public removeItem(item) {
      this._tfmService.log(item);

      if (item.id) {
        if (item.returnServicePoint >= 0 && this.view.data.cart.filter(x=>x.point == item.returnServicePoint && x.id == item.id).length > 0) {
          var returnItem = this.view.data.cart.filter(x=>x.point == item.returnServicePoint && x.id == item.id)[0];
          var returnItemRemoved = this._tfmCartService.removeItem(returnItem);

          // if (returnItemRemoved)
          //   this.cartItemChange.emit({event:'removed', item: returnItem});
        }

        this._tfmCartService.removeItem(item);

        this._cd.detectChanges();
      }
    }

    public clearCart() {
      this._tfmCartService.clearCart();

      this._cd.detectChanges();
    }

    public async createItin(referenceId = 0, itinObject = null): Promise<void> {
      var itinGUID = this._tfmService.getLocalItinGuid();

      this._tfmService.log("createItin", itinGUID, referenceId);
      this._tfmService.log("createItin", "cartItems", this.view.cart);

      if (this._options.isClient) {
        this._tfmService.clearLocalItinGuid();
        itinGUID = null;

        this.view.itin = {
          content: {
            itinerary: {
              description: "Client quotation request"
            }
          }
        };

        itinObject = this.view.itin.content.itinerary;
      }

      if (referenceId > 0) {
        this.view.itin.content.itinerary.referenceID = referenceId;
        if (itinObject) itinObject.referenceID = referenceId;
      }

      if (!itinGUID) {
        try {
          // Create master quote
          const res = await firstValueFrom(this._tfmService.createItin(itinObject));

          this._tfmService.saveLocalStorage("itinRef", res.content.itinerary.id);
          this._tfmService.setLocalItinGuid(res.content.itinerary.guid);

          this.quoteCreatePostProcess(res);
          console.log('Master Id ' + res.content.itinerary.id);
          await this.getItinQuotes(res.content.itinerary.id);
        } catch (error) {
          console.error('Failed to create master quote:', error);
        }
      } else {
        try {
          // Link other quotes to master quote
          this._tfmService.setLocalItinGuid(itinGUID);
          const res = await firstValueFrom(this._tfmService.getItin(itinGUID));

          const unprocessedHotels = this.view.data.cart.filter(x => !x.processed && x.type === "hotel");

          if (unprocessedHotels.length > 0) {
            const newRes = await firstValueFrom(this._tfmService.createItin(itinObject));
            this.quoteCreatePostProcess(newRes);
            console.log('Created new option for ' + newRes.content.itinerary.id);
            await this.getItinQuotes(newRes.content.itinerary.referenceID);
          } else {
            this.quoteCreatePostProcess(res);
            console.log('Added to existing quote ' + res.content.itinerary.id);
            await this.getItinQuotes(res.content.itinerary.id);
          }
        } catch (error) {
          console.error('Failed to retrieve or create itin:', error);
        }
      }
    }

    onRefreshCart(){
      this.getItin();
    }
    queryStringGuid : any;
    getItinQuotes(referenceID) {
      if (referenceID) {
        this._tfmService.getItinOptions(referenceID).subscribe(resOptions => {
          if (!resOptions) return;

          if (Array.isArray(resOptions.content)) {
            resOptions.content.sort((a, b) => a.itinerary.option - b.itinerary.option);
          }

          this.view.quotes = resOptions;

          this._tfmService.log("QUOTE OPTIONS", this.view);
          this.view.quotesAll = Array.isArray(resOptions.content)
            ? resOptions.content.map(item => `guids=${item.itinerary.guid}`).join("&")
            : '';

          if (this.view.quotes?._links) {
            this.view.quotes._links.forEach(l => {
              l.href = l.href.replace("http://", "https://");
            });
          }

          this._cd.detectChanges();
        });
      }
    }
    async getItinItems(quote) {
      this._tfmService.getItinItems(quote.itinerary.guid).subscribe(res => {
        quote.items = res;
        console.log('items',quote.items)
      });

      this._tfmService.log("QUOTE ITEMS", quote.itinerary.option, quote);
    }
    quoteCreatePostProcess(res){
        this._tfmService.log("quoteCreatePostProcess", "cartItems", this.view.cart);

        this._tfmService.setLocalItinGuid(res.content.itinerary.guid);
        this.view.itin = res;

        var count = 0;
        this.view.data.cart.filter(x=>{
          x.addedToQuote = false;
        });

        this._tfmService.log("cartItems to add to quote", this.view.data.cart);

        //Loop through cart items, check type and call add-item extension to create quote/itin
        this.view.data.cart.filter(x=>!x.processed).forEach(service => {
          if (service.type == 'hotel') {
            var roomsToAdd = service.item.rooms.filter(x=>x.selected).length;
            var roomsAdded = 0;
            service.item.rooms.forEach(room => {
              if (room.selected) {
                room.basis.forEach(basis => {
                  if (basis.selected) { //We need to add this to the quote
                    this._tfmService.log("adding room and basis", room.rph, room.name, basis.name);
                    const basisLinks = this._tfmService.getExtensionsLinks(basis.extensions);
                    const link = this._tfmService.getLink(basisLinks, "add-item");
                    if (!link) {
                      this._tfmService.log("add-item link missing for hotel basis", basis);
                      roomsAdded++;
                      if (roomsAdded === roomsToAdd) count++;
                      return;
                    }
                    link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);

                    this._tfmService.send(link, 'add-item').subscribe(res => {
                      this._tfmService.log(res);

                      roomsAdded++;
                      if (roomsAdded == roomsToAdd) {
                        count++;
                        // if (count == this.view.data.cart.length)
                        //   this.getItin(false, 'view-quote');
                      }
                    });
                  }
                });
              }
            });
          }
          else if (service.type == 'flight') {
            if (this.view.data.cart.filter(x=>x.type == 'flight' && x.addedToQuote && x.id == service.item.id).length == 0) {
              const flightLinks = this._tfmService.getExtensionsLinks(service.item.extensions);
              const link = this._tfmService.getLink(flightLinks, "add-item");
              if (!link) {
                this._tfmService.log("add-item link missing for flight", service.item);
                count++;
              } else {
                link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
                service.addedToQuote = true;

                this._tfmService.send(link, 'add-item').subscribe(res => {
                this._tfmService.log(res);

                count++;
                // if (count == this.view.data.cart.length)
                //   this.getItin(false, 'view-quote');
              });
              }
            }
            else {
              count++;
                // if (count == this.view.data.cart.length)
                //   this.getItin(false, 'view-quote');
            }
          }
          else if (service.type == 'transfer') {
            const transferLinks = this._tfmService.getExtensionsLinks(service.item.extensions);
            const link = this._tfmService.getLink(transferLinks, "add-item");
            if (!link) {
              this._tfmService.log("add-item link missing for transfer", service.item);
              count++;
            } else {
              link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
              this._tfmService.send(link, 'add-item').subscribe(res => {
                this._tfmService.log(res);
                count++;
              });
            }
          }
          else if (service.type == 'car') {
            const carLinks = this._tfmService.getExtensionsLinks(service.item.extensions);
            const link = this._tfmService.getLink(carLinks, "add-item");
            if (!link) {
              this._tfmService.log("add-item link missing for car", service.item);
              count++;
            } else {
              link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
              this._tfmService.send(link, 'add-item').subscribe(res => {
                this._tfmService.log(res);
                count++;
              });
            }
          }
          else if (service.type == 'activity') {
            const activityLinks = this._tfmService.getExtensionsLinks(service.item.extensions);
            const link = this._tfmService.getLink(activityLinks, "add-item");
            if (!link) {
              this._tfmService.log("add-item link missing for activity", service.item);
              count++;
            } else {
              link.href = link.href.replace("{itineraryId}", res.content.itinerary.id);
              this._tfmService.send(link, 'add-item').subscribe(res => {
                this._tfmService.log(res);
                count++;
              });
            }
          }

          service.processed = true;
        });

        this._tfmService.log("quoteCreatePostProcess", "redirect", this._options);
        if (this._options.isClient) {
          setTimeout(() => {
            this._tfmCartService.clearCart(true);
          }, 2000);
          this.quoteCreated.emit(res.content.itinerary.guid);
        }
        else {
          // Delay clearing so getItinQuotes has time to return before cartChange fires
          setTimeout(() => {
            this._tfmCartService.clearCart(true);
          }, 1500);
        }
    }
    // tripChanged(item) {
    //   this._tfmService.log(item);

    //   this.view.trip = item;
    // }

    // cartChanged(item) {
    //   if (item.action == 'add')
    //     this.selectItem(item.item, item.type);
    //   else if (item.action == 'remove')
    //     this.removeItem(item.item);
    // }

    /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
